import { Map, List } from "immutable";

import {
  PARTNERSHIP_LIST_REQUEST,
  PARTNERSHIP_LIST_SUCCESS,
  PARTNERSHIP_LIST_FAILURE,
  PARTNERSHIP_READ_REQUEST,
  PARTNERSHIP_READ_SUCCESS,
  PARTNERSHIP_READ_FAILURE,
  PARTNERSHIP_CREATE_REQUEST,
  PARTNERSHIP_CREATE_SUCCESS,
  PARTNERSHIP_CREATE_FAILURE,
  PARTNERSHIP_UPDATE_REQUEST,
  PARTNERSHIP_UPDATE_SUCCESS,
  PARTNERSHIP_UPDATE_FAILURE,
  PARTNERSHIP_DELETE_REQUEST,
  PARTNERSHIP_DELETE_SUCCESS,
  PARTNERSHIP_DELETE_FAILURE,
  PARTNERSHIP_FORM_DESTROY,
  PARTNERSHIP_CSV_DOWNLOAD_REQUEST,
  PARTNERSHIP_CSV_DOWNLOAD_SUCCESS,
  PARTNERSHIP_CSV_DOWNLOAD_FAILURE,
} from "./actions";
import Logger from "../../../lib/Logger";

export default function partnerships(
  state = Map({
    isLoading: false,
    isCSVDownloading: false,
    pages: {},
  }),
  action
) {
  Logger.log(
    "debug",
    `[partnerships.reducers] partnerships(%j, %j)`,
    state,
    action
  );

  switch (action.type) {
    case PARTNERSHIP_LIST_REQUEST:
      return state.mergeDeep({
        isLoading: true,
      });

    case PARTNERSHIP_LIST_SUCCESS:
      return state
        .mergeDeep({
          isLoading: false,
          pages: {
            [action.order]: {
              [action.limit]: {
                [action.page]: null,
              },
            },
          },
          total: action.total,
          lastUpdated: action.receivedAt,
        })
        .setIn(
          ["pages", action.order, action.limit, action.page],
          List(action.result)
        );

    case PARTNERSHIP_LIST_FAILURE:
      return state.mergeDeep({
        isLoading: false,
      });

    case PARTNERSHIP_READ_REQUEST:
      return state.mergeDeep({
        isLoading: true,
      });

    case PARTNERSHIP_READ_SUCCESS:
      return state.mergeDeep({
        isLoading: false,
        lastUpdated: action.receivedAt,
      });

    case PARTNERSHIP_READ_FAILURE:
      return state.mergeDeep({
        isLoading: false,
      });

    case PARTNERSHIP_UPDATE_REQUEST:
      return state.mergeDeep({
        isLoading: true,
        form: {
          isSubmitting: true,
          success: null,
          errors: null,
        },
      });

    case PARTNERSHIP_UPDATE_SUCCESS:
      return state.mergeDeep({
        isLoading: false,
        form: {
          isSubmitting: false,
          success: true,
          errors: null,
        },
        lastUpdated: action.receivedAt,
      });

    case PARTNERSHIP_UPDATE_FAILURE:
      return state
        .mergeDeep({
          isLoading: false,
          form: {
            isSubmitting: false,
            success: false,
            errors: null,
          },
        })
        .setIn(["form", "errors"], action.error);

    case PARTNERSHIP_DELETE_REQUEST:
      return state.mergeDeep({
        isLoading: true,
      });

    case PARTNERSHIP_DELETE_SUCCESS:
      return state.mergeDeep({
        isLoading: false,
        lastUpdated: action.receivedAt,
      });

    case PARTNERSHIP_DELETE_FAILURE:
      return state.mergeDeep({
        isLoading: false,
      });

    case PARTNERSHIP_FORM_DESTROY:
      return state
        .mergeDeep({
          form: null,
        })
        .set("form", action.form);

    case PARTNERSHIP_CSV_DOWNLOAD_REQUEST:
      return state.mergeDeep({
        isCSVDownloading: true,
      });

    case PARTNERSHIP_CSV_DOWNLOAD_SUCCESS:
      return state.mergeDeep({
        isCSVDownloading: false,
      });

    case PARTNERSHIP_CSV_DOWNLOAD_FAILURE:
      return state.mergeDeep({
        isCSVDownloading: false,
      });

    case PARTNERSHIP_CREATE_REQUEST:
      return state.mergeDeep({
        isLoading: true,
        form: {
          isSubmitting: true,
          success: null,
          errors: null,
        },
      });

    case PARTNERSHIP_CREATE_SUCCESS:
      return state.mergeDeep({
        isLoading: false,
        form: {
          isSubmitting: false,
          success: true,
          created_id: action.id,
          errors: null,
        },
        lastUpdated: action.receivedAt,
      });

    case PARTNERSHIP_CREATE_FAILURE:
      return state
        .mergeDeep({
          isLoading: false,
          form: {
            isSubmitting: false,
            success: false,
            errors: null,
          },
        })
        .setIn(["form", "errors"], action.error);
  
    
    default:
      return state;
  }
}

Logger.log("silly", `partnerships.reducers loaded.`);
